// Public Supabase config. Which PROJECT this points at is decided at BUILD TIME
// by `tools/platform-env.mjs` (ADR-0016, wired 2026-09-06): CF_PAGES_BRANCH
// `main` -> production, everything else -> staging. It was a hardcoded
// production URL here, which is why the staging project had no client and every
// branch preview read and WROTE to production.
//
// The publishable key is browser-safe either way — it ships inside the bundle
// and RLS plus column grants are what enforce access. Server-only secrets never
// appear in this file; check E10 scans the built output for them.
//
// The `typeof` guard is not defensiveness: outside a build that defines these
// (a bare `tsc`, an editor) the identifier does not exist at all, and reading it
// would be a ReferenceError rather than `undefined`.
const TARGET = {
  url: typeof __PLATFORM_SUPABASE_URL__ === 'string' ? __PLATFORM_SUPABASE_URL__ : '',
  key:
    typeof __PLATFORM_SUPABASE_PUBLISHABLE_KEY__ === 'string'
      ? __PLATFORM_SUPABASE_PUBLISHABLE_KEY__
      : '',
  apiBase: typeof __PLATFORM_API_BASE__ === 'string' ? __PLATFORM_API_BASE__ : '',
};

/** 'production' on a `main` build, 'staging' on every other one. */
export const PLATFORM_ENV = typeof __PLATFORM_ENV__ === 'string' ? __PLATFORM_ENV__ : 'unknown';

export const SUPABASE_URL = TARGET.url;
export const SUPABASE_PUBLISHABLE_KEY = TARGET.key;

// Origin serving the chat edge functions (they deploy with the SITE CF Pages
// project, not this SPA's). The dedicated chat host (ADR-0008) serves /api/*
// both before and after the WP-exit cutover — never point this at the apex
// pre-cutover (WordPress owns it and would 404). Pair with
// CHAT_ALLOWED_ORIGIN = this app's origin on the site project (RUNBOOK §14).
export const CHAT_API_BASE = TARGET.apiBase;

// VAPID PUBLIC key for Web Push alerts (Increment C4) — the browser needs it
// to subscribe; it is public by design (the PRIVATE key lives only in the
// site project's CF env). Empty until the operator generates the pair
// (RUNBOOK §15); the alerts button stays hidden while empty.
export const VAPID_PUBLIC_KEY =
  'BIpzftqOENyHoTgVF8pgfvG8k57CHBgzuUAGKIbJjfcbyMNgq6yQqCpy_IQaGSr4xayt0xKo2VLP7esQhQU3_XQ';
